import Axios from "axios";
import { baseUrl } from "../config/base-url";

export function getUser() {
  return Axios({
    url: `${baseUrl()}/user`,
    method: "GET",
    headers: {
      Authorization:
        `Bearer ` + (localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")).user?.tk : null),
    },
  });
}
